import { newStorage } from './storage';

const adminsTableStorage = newStorage('TABLE_ADMINS');

export default adminsTableStorage;
